import e from"./Snippet.vue_vue&type=script&lang.js";import{render as p}from"./Snippet.vue_vue&type=template&id=edc35952&lang.js";e.render=p;export default e;
//# sourceMappingURL=Snippet.vue.js.map
